import { Component, OnInit } from '@angular/core';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { Subscription } from 'rxjs';
import { DetalleDocumentosService } from './documentos.service';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { DetalleEstablecimientoService } from '../establecimiento/establecimiento.service';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { AuthService } from 'src/app/shared/services/auth.service';
import { TipoCampoAdicional } from 'src/app/shared/enumeraciones/tipo-campo-adicional.enum';
import { CamposAdicionalesEnum } from 'src/app/shared/enumeraciones/campos-adicionales.enum';

@Component({
  selector: "app-documentos",
  templateUrl: "./documentos.component.html",
  styleUrls: ["./documentos.component.scss"],
})
export class DocumentosComponent implements OnInit {
  headersDocumentos: Array<string>;
  headersVehiculos: Array<string>;
  documentos: Array<any> = [];
  documentos_anterior: Array<any> = [];
  datoSolicitudSharedModel: DatoSolicitudSharedModel;
  suscripcion: Subscription;
  camposTurismoAventura: Array<any> = [];
  camposVehiculos: Array<any> = [];
  camposAdicionales: Array<any> = [];
  camposTurismoAventura_anterior: Array<any> = [];
  camposAdicionales_anterior: Array<any> = [];
  camposVehiculos_anterior: Array<any> = [];
  tipo_prestador = RolesUsuario.Prestador;
  arrayRespuestaMultipleDocumento: Array<any> = [];
  arrayDocumento: Array<any> = [];
  arrayRespuestaMultiple: Array<any> = [];
  arrayCampoAdicional: Array<any> = [];
  isCampoAdicional: boolean;
  isAnteriorCA: boolean = false;
  isAnteriorDoc: boolean = false;
  arrayRespuestaMultipleAnterior: Array<any> = [];
  arrayCampoAdicionalAnterior: Array<any> = [];
  arrayRespuestaMultipleAnteriorDocumento: Array<any> = [];
  arrayDocumentoAnterior: Array<any> = [];
  backgroundActual: string = 'versionActual';
  backgroundAnterior: string = 'versionAnterior';

  constructor(
    private detalleDocumentosService: DetalleDocumentosService,
    private dataSharedService: DataSharedService,
    public authService: AuthService
  ) {
    this.suscripcion = this.dataSharedService.data$.subscribe((dataShared) => {
      this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
    });
  }

  ngOnInit() {
    this.documentos = [] as Array<any>;
    this.headersDocumentos = ['Requisito', '¿ Cumple ?', 'No. Certificado'];
    this.headersVehiculos = ['Marca', 'Linea', 'Placa', 'Color'];

    this.getDataCampoAdicional();
    this.getDataDocumento();
  }

  get TipoCampoAdicional() {
    return TipoCampoAdicional;
  }

  get CamposAdicionalesEnum() {
    return CamposAdicionalesEnum;
  }

  getDataCampoAdicional() {
    this.detalleDocumentosService
      .getCamposAdicionales(this.datoSolicitudSharedModel.data)
      .subscribe((response) => {
        if (response.data) {
          if (response.data[0].preguntas.length > 0) {
            this.isCampoAdicional = true;

            response.data.forEach((respuesta) => {
              if (respuesta.flag === "Actual") {
                this.isAnteriorCA = false;
                this.camposAdicionales.push(respuesta);
                this.formatObject(this.camposAdicionales[0].preguntas);
              } else {
                this.isAnteriorCA = true;
                this.camposAdicionales_anterior.push(respuesta);
                this.formatObject(this.camposAdicionales_anterior[0].preguntas);
              }
            });

            this.getDifferencesRequisitos('campoAdicional');
          }
        }
      });
  }

  getDataDocumento() {
    this.detalleDocumentosService
      .getDocumentos(this.datoSolicitudSharedModel.data)
      .subscribe((res) => {
        if (res.data) {
          this.isCampoAdicional = false;

          res.data.forEach((respuesta) => {
            if (respuesta.flag === "Actual") {
              this.isAnteriorDoc = false;
              this.documentos.push(respuesta);

              if (respuesta.preguntas.length > 0) {
                this.formatObject(this.documentos[0].preguntas);
              }
            } else {
              this.isAnteriorDoc = true;
              this.documentos_anterior.push(respuesta);
              this.formatObject(this.documentos_anterior[0].preguntas);

              /*if(respuesta.preguntas.length > 0){
                this.formatObject(this.documentos[1].preguntas);
              }*/
            }
          });

          this.getDifferencesRequisitos('documento');
        }
      });
  }

  formatObject(respuestas) {
    let data = respuestas;

    for (let i = 0; i < data.length; i++) {
      let tmp = data[i];
      let objData: any;
      this.arrayRespuestaMultipleDocumento = [];
      this.arrayRespuestaMultipleAnteriorDocumento = [];
      this.arrayRespuestaMultipleAnterior = [];
      this.arrayRespuestaMultiple = [];

      if (tmp.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica) {
        objData = {
          id: tmp.documento_id,
          desc_tipo_dato: tmp.desc_tipo_dato,
          titulo: null,
          titulo_varios_registros: null,
          respuesta: null,
          turismoAventura: null,
          numero_certificado: tmp.numero_certificado,
          backgroundColor: '',
          multipleCaracterisitca: tmp.caracteristicas_Opciones,
          hijasMultiple: null,
        };

        if (this.isCampoAdicional) {
          objData.titulo = tmp.titulo;
          objData.turismoAventura = null;
          objData.vehiculos = null;

          if (this.isAnteriorCA) {
            this.arrayCampoAdicionalAnterior.push(objData);
          } else {
            this.arrayCampoAdicional.push(objData);
          }
        } else {
          objData.titulo = tmp.descripcion;

          if (this.isAnteriorDoc) {
            this.arrayDocumentoAnterior.push(objData);
          } else {
            this.arrayDocumento.push(objData);
          }
        }
      } else if (tmp.desc_tipo_dato === TipoCampoAdicional.Multiple) {
        let tempMult = {
          id: tmp.documento_id,
          desc_tipo_dato: tmp.desc_tipo_dato,
          titulo: null,
          numero_certificado: tmp.numero_certificado,
          backgroundColor: '',
          respuesta: tmp.respuesta.valor,
          caracteristicas_Opciones: null,
          turismoAventura: null
        };

        if (this.isCampoAdicional) {
          // Campo Adicional
          tempMult.titulo = tmp.titulo;

          if (this.isAnteriorCA) {
            // Anterior
            this.arrayRespuestaMultipleAnterior.push(tempMult);
          } else {
            // Actual
            this.arrayRespuestaMultiple.push(tempMult);
          }
        } else {
          // Documento
          tempMult.titulo = tmp.descripcion;

          if (this.isAnteriorDoc) {
            this.arrayRespuestaMultipleAnteriorDocumento.push(tempMult);
          } else {
            this.arrayRespuestaMultipleDocumento.push(tempMult);
          }
        }

        if (tmp.respuesta.preguntas_hijas.length > 0) {
          this.getRespuestasHijas(tmp.respuesta.preguntas_hijas[0]);
        }

        objData = {
          desc_tipo_dato: tmp.desc_tipo_dato,
          titulo: "",
          titulo_varios_registros: null,
          respuesta: null,
          multipleCaracterisitca: null,
          turismoAventura: null,
          hijasMultiple: null,
        };

        if (this.isCampoAdicional) {
          if (this.isAnteriorCA) {
            objData.hijasMultiple = this.arrayRespuestaMultipleAnterior;
            this.arrayCampoAdicionalAnterior.push(objData);
          } else {
            objData.hijasMultiple = this.arrayRespuestaMultiple;
            this.arrayCampoAdicional.push(objData);
          }
        } else {
          if (this.isAnteriorDoc) {
            objData.hijasMultiple =
              this.arrayRespuestaMultipleAnteriorDocumento;
            this.arrayDocumentoAnterior.push(objData);
          } else {
            objData.hijasMultiple = this.arrayRespuestaMultipleDocumento;
            this.arrayDocumento.push(objData);
          }
        }
      } else if (tmp.desc_tipo_dato === TipoCampoAdicional.VariosRegistros) {
        objData = {
          id: tmp.documento_id,
          desc_tipo_dato: tmp.desc_tipo_dato,
          titulo: null,
          numero_certificado: tmp.numero_certificado,
          backgroundColor: '',
          turismoAventura: null,
          titulo_varios_registros: tmp.nombre_varios_registros,
          respuesta: tmp.valor_varios_registros,
          multipleCaracterisitca: null,
          hijasMultiple: null,
        };

        if (this.isCampoAdicional) {
          objData.titulo = tmp.titulo;
          objData.turismoAventura = null;
          objData.vehiculos = null;

          if (this.isAnteriorCA) {
            this.arrayCampoAdicionalAnterior.push(objData);
          } else {
            this.arrayCampoAdicional.push(objData);
          }
        } else {
          objData.titulo = tmp.descripcion;

          if (this.isAnteriorDoc) {
            this.arrayDocumentoAnterior.push(objData);
          } else {
            this.arrayDocumento.push(objData);
          }
        }
      } else {
        objData = {
          id: tmp.documento_id,
          desc_tipo_dato: tmp.desc_tipo_dato,
          titulo: null,
          numero_certificado: tmp.numero_certificado,
          backgroundColor: '',
          titulo_varios_registros: null,
          respuesta: tmp.respuesta.valor,
          multipleCaracterisitca: null,
          hijasMultiple: null,
        };

        if (this.isCampoAdicional) {
          objData.titulo = tmp.titulo;
          objData.turismoAventura = null;
          objData.vehiculos = null;

          if (this.isAnteriorCA) {
            //Si es tipo BIT
            if (tmp.desc_tipo_dato === TipoCampoAdicional.Booleano) {
              // Si es tipo Turismo aventura
              if (tmp.documento_id === CamposAdicionalesEnum.EsTurismoAventura) {
                this.detalleDocumentosService.getDetalleTurismo(this.datoSolicitudSharedModel.data).subscribe(response => {
                  let arrayTurismoAventuraAnterior: Array<any> = [];
                  let arrayTurismoAventuraActual: Array<any> = [];

                  for (let i = 0; i < response.data.length; i++) {
                    let temp = response.data[i];
                    if (temp.flag === 'Anterior') {
                      arrayTurismoAventuraAnterior.push(temp);
                    } else if(temp.flag === 'Actual'){
                      arrayTurismoAventuraActual.push(temp);
                    }
                  }

                  // Obtenemos las diferencias ambos objetos (COLOR VERSIONES)
                  const difference = [
                    ...this.getDifference(arrayTurismoAventuraActual, arrayTurismoAventuraAnterior),
                    ...this.getDifference(arrayTurismoAventuraAnterior, arrayTurismoAventuraActual)
                  ];

                  // Coloreamos las diferencias en la version Anterior
                  for(let i=0; i < difference.length; i++){
                    let temp = difference[i];

                    if(temp.flag === 'Anterior'){
                      arrayTurismoAventuraAnterior.find( (element, index) => {
                        if(element.tipo_turismo_aventura_id === temp.tipo_turismo_aventura_id){
                          arrayTurismoAventuraAnterior[index].backgroundColor = this.backgroundAnterior;
                        }
                      });
                    }
                  }

                  objData.turismoAventura = arrayTurismoAventuraAnterior;
                  
                });
              } else if (tmp.documento_id === CamposAdicionalesEnum.RelacionarVehiculos) {
                this.detalleDocumentosService.getVehiculos(this.datoSolicitudSharedModel.data).subscribe((response) => {
                  let arrayVehiculo: Array<any> = [];

                  if (response.data) {
                    for (let i = 0; i < response.data.length; i++) {
                      let temp = response.data[i];
                      let data: any;

                      if (temp.flag === 'Anterior') {
                        data = {
                          marca: temp.desc_marca,
                          linea: temp.desc_linea,
                          placa: temp.placa,
                          color: temp.color
                        }

                        arrayVehiculo.push(data);
                      }
                    }

                    objData.vehiculos = arrayVehiculo;
                  }
                });
              }
            }

            this.arrayCampoAdicionalAnterior.push(objData);
          } else {
            //Si es tipo BIT
            if (tmp.desc_tipo_dato === TipoCampoAdicional.Booleano) {
              // Si es tipo Turismo aventura
              if (tmp.documento_id === CamposAdicionalesEnum.EsTurismoAventura) {
                this.detalleDocumentosService.getDetalleTurismo(this.datoSolicitudSharedModel.data).subscribe(response => {
                  let arrayTurismoAventuraActual: Array<any> = [];
                  let arrayTurismoAventuraAnterior: Array<any> = [];

                  if (response.data) {
                    for (let i = 0; i < response.data.length; i++) {
                      let temp = response.data[i];

                      if (temp.flag === 'Actual') {
                        arrayTurismoAventuraActual.push(temp);
                      } else if(temp.flag === 'Anterior'){
                        arrayTurismoAventuraAnterior.push(temp);
                      }
                    }

                    // Obtenemos las diferencias ambos objetos (COLOR VERSIONES)
                    const difference = [
                      ...this.getDifference(arrayTurismoAventuraActual, arrayTurismoAventuraAnterior),
                      ...this.getDifference(arrayTurismoAventuraAnterior, arrayTurismoAventuraActual)
                    ];

                    // Coloreamos las diferencias en la version Actual
                    for(let i=0; i < difference.length; i++){
                      let temp = difference[i];

                      if(temp.flag === 'Actual'){
                        arrayTurismoAventuraActual.find( (element, index) => {
                          if(element.tipo_turismo_aventura_id === temp.tipo_turismo_aventura_id){
                            arrayTurismoAventuraActual[index].backgroundColor = this.backgroundActual;
                          }
                        });
                      }
                    }
                    
                    objData.turismoAventura = arrayTurismoAventuraActual;
                  }
                });
              } else if (tmp.documento_id === CamposAdicionalesEnum.RelacionarVehiculos) {
                this.detalleDocumentosService.getVehiculos(this.datoSolicitudSharedModel.data).subscribe((response) => {
                  let arrayVehiculo: Array<any> = [];

                  if (response.data) {
                    for (let i = 0; i < response.data.length; i++) {
                      let temp = response.data[i];
                      let data: any;

                      if (temp.flag === 'Actual') {
                        data = {
                          marca: temp.desc_marca,
                          linea: temp.desc_linea,
                          placa: temp.placa,
                          color: temp.color
                        }

                        arrayVehiculo.push(data);
                      }
                    }
                    objData.vehiculos = arrayVehiculo;
                  }
                });
              }
            }
            this.arrayCampoAdicional.push(objData);
          }
        } else {
          objData.titulo = tmp.descripcion;

          if (this.isAnteriorDoc) {
            this.arrayDocumentoAnterior.push(objData);
          } else {
            this.arrayDocumento.push(objData);
          }
        }
      }
    }
  }

  getDifference(array1, array2) {
    return array1.filter(object1 => {
      return !array2.some(object2 => {
        return object1.tipo_turismo_aventura_id === object2.tipo_turismo_aventura_id;
      });
    });
  }

  getRespuestasHijas(objRespuestas) {
    let temp: any;

    if (objRespuestas.desc_tipo_dato === TipoCampoAdicional.Multiple) {
      temp = {
        id: objRespuestas.documento_id,
        desc_tipo_dato: objRespuestas.desc_tipo_dato,
        titulo: objRespuestas.descripcion,
        respuesta: objRespuestas.respuesta.valor,
        caracteristicas_Opciones: null,
      };

      if (this.isCampoAdicional) {
        // Campo adicional
        if (this.isAnteriorCA) {
          // Anterior
          this.arrayRespuestaMultipleAnterior.push(temp);
        } else {
          // Actual
          this.arrayRespuestaMultiple.push(temp);
        }
      } else {
        // Documento
        if (this.isAnteriorDoc) {
          // Anterior
          this.arrayRespuestaMultipleAnteriorDocumento.push(temp);
        } else {
          // Actual
          this.arrayRespuestaMultipleDocumento.push(temp);
        }
      }

      if (objRespuestas.respuesta.preguntas_hijas.length > 0) {
        this.getRespuestasHijas(objRespuestas.respuesta.preguntas_hijas[0]);
      }
    } else if (
      objRespuestas.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica
    ) {
      temp = {
        id: objRespuestas.documento_id,
        desc_tipo_dato: objRespuestas.desc_tipo_dato,
        titulo: objRespuestas.descripcion,
        respuesta: objRespuestas.respuesta.valor,
        caracteristicas_Opciones: objRespuestas.caracteristicas_Opciones,
      };

      if (this.isCampoAdicional) {
        if (this.isAnteriorCA) {
          this.arrayRespuestaMultipleAnterior.push(temp);
        } else {
          this.arrayRespuestaMultiple.push(temp);
        }
      } else {
        if (this.isAnteriorDoc) {
          this.arrayRespuestaMultipleAnteriorDocumento.push(temp);
        } else {
          this.arrayRespuestaMultipleDocumento.push(temp);
        }
      }
    } else if (objRespuestas.desc_tipo_dato === TipoCampoAdicional.VariosRegistros) {
      temp = {
        id: objRespuestas.documento_id,
        desc_tipo_dato: objRespuestas.desc_tipo_dato,
        titulo: objRespuestas.descripcion,
        respuesta: objRespuestas.valor_varios_registros,
        caracteristicas_Opciones: null
      }

      if (this.isCampoAdicional) {
        if (this.isAnteriorCA) {
          this.arrayRespuestaMultipleAnterior.push(temp);
        } else {
          this.arrayRespuestaMultiple.push(temp);
        }
      } else {
        if (this.isAnteriorDoc) {
          this.arrayRespuestaMultipleAnteriorDocumento.push(temp);
        } else {
          this.arrayRespuestaMultipleDocumento.push(temp);
        }
      }
    } else {
      temp = {
        id: objRespuestas.documento_id,
        desc_tipo_dato: objRespuestas.desc_tipo_dato,
        titulo: "",
        respuesta: objRespuestas.respuesta.valor,
        caracteristicas_Opciones: null,
      };

      if (this.isCampoAdicional) {
        temp.titulo = objRespuestas.titulo;

        if (this.isAnteriorCA) {
          this.arrayRespuestaMultipleAnterior.push(temp);
        } else {
          this.arrayRespuestaMultiple.push(temp);
        }
      } else {
        temp.titulo = objRespuestas.descripcion;
        if (this.isAnteriorDoc) {
          this.arrayRespuestaMultipleAnteriorDocumento.push(temp);
        } else {
          this.arrayRespuestaMultipleDocumento.push(temp);
        }
      }
    }
  }

  getTurismoAdventura(option) {
    this.detalleDocumentosService.getDetalleTurismo(this.datoSolicitudSharedModel.data).subscribe(response => {
      if (option === 'actual') {
        this.camposTurismoAventura = response.data;
      } else if (option === 'anterior') {
        this.camposTurismoAventura_anterior = response.data;
      }
    });
  }

  getDifferencesRequisitos(option) {
    if (option === 'campoAdicional') {
      let arrayPreguntasMultiples: Array<any> = [];
      let arrayPreguntasMultiplesActual: Array<any> = [];

      // Obtener listado preguntas tipo MULTIPLE version anterior
      for (let i = 0; i < this.arrayCampoAdicionalAnterior.length; i++) {
        let temp = this.arrayCampoAdicionalAnterior[i];

        if (temp.desc_tipo_dato === TipoCampoAdicional.Multiple) {
          temp.index = i;
          arrayPreguntasMultiples.push(temp);
        }
      }
      // Obtener listado preguntas tipo MULTIPLE version Actual
      for (let i = 0; i < this.arrayCampoAdicional.length; i++) {
        let temp = this.arrayCampoAdicional[i];

        if (temp.desc_tipo_dato === TipoCampoAdicional.Multiple) {
          temp.index = i;
          arrayPreguntasMultiplesActual.push(temp);
        }
      }

      // Recorremos las preguntas a mostrar
      for (let i = 0; i < this.arrayCampoAdicional.length; i++) {
        let temp = this.arrayCampoAdicional[i];
        let tempAnterior: any;
        let indextempAnterior: number;

        if (temp.desc_tipo_dato === TipoCampoAdicional.Multiple) {
          let preguntasHijasAnterior: any;
          let preguntasHijasActual = temp.hijasMultiple;

          // Buscar la pregunta multiple version anterior
          for (let k = 0; k < arrayPreguntasMultiples.length; k++) {
            let tempMult = arrayPreguntasMultiples[k].hijasMultiple;

            if (temp.hijasMultiple[0].id === tempMult[0].id) {
              preguntasHijasAnterior = arrayPreguntasMultiples[k];
              break;
            }
          }

          //validar preguntas anteriores
          if (preguntasHijasAnterior !== undefined) {
            if (preguntasHijasAnterior.hijasMultiple.length > temp.hijasMultiple.length) {
              for (let i = 0; i < preguntasHijasAnterior.hijasMultiple.length; i++) {
                this.arrayCampoAdicionalAnterior[preguntasHijasAnterior.index].hijasMultiple[i].backgroundColor = this.backgroundAnterior;
              }
            }
          }

          for (let j = 0; j < preguntasHijasActual.length; j++) {
            let tempHijasActual = preguntasHijasActual[j];

            if (preguntasHijasAnterior !== undefined) {
              if (preguntasHijasAnterior.hijasMultiple[j]) { // edicion
                if (preguntasHijasAnterior.hijasMultiple[j].respuesta != tempHijasActual.respuesta) {
                  this.arrayCampoAdicional[i].hijasMultiple[j].backgroundColor = this.backgroundActual;
                  this.arrayCampoAdicionalAnterior[preguntasHijasAnterior.index].hijasMultiple[j].backgroundColor = this.backgroundAnterior;
                }
                if (tempHijasActual.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica) {
                  for (let k = 0; k < tempHijasActual.caracteristicas_Opciones.length; k++) {
                    // let tempHijasActual_Multiple = tempHijasActual.caracteristicas_Opciones[k];
                    if (preguntasHijasAnterior.hijasMultiple[j].caracteristicas_Opciones[k].Valor_Registros != tempHijasActual.caracteristicas_Opciones[k].Valor_Registros) {
                    this.arrayCampoAdicional[i].hijasMultiple[j].caracteristicas_Opciones[k].backgroundColor = this.backgroundActual;
                    this.arrayCampoAdicionalAnterior[preguntasHijasAnterior.index].hijasMultiple[j].caracteristicas_Opciones[k].backgroundColor = this.backgroundAnterior;
                    }
                  }
                }
              } else { // nueva
                this.arrayCampoAdicional[i].hijasMultiple[j].backgroundColor = this.backgroundActual;
                if (tempHijasActual.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica) {
                  for (let f = 0; f < tempHijasActual.caracteristicas_Opciones.length; f++) {
                    // let tempHijasActual_Multiple = tempHijasActual.caracteristicas_Opciones[k];
                    this.arrayCampoAdicional[i].hijasMultiple[j].caracteristicas_Opciones[f].backgroundColor = this.backgroundActual;
                  }
                }
              }
            } else {
              this.arrayCampoAdicional[i].hijasMultiple[j].backgroundColor = this.backgroundActual;
            }
          }
        } else if (temp.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica) {
          tempAnterior = this.arrayCampoAdicionalAnterior.find(element => element.id === temp.id);

          if (tempAnterior === undefined) {
            this.arrayCampoAdicional[i].backgroundColor = this.backgroundActual;
            // this.arrayCampoAdicionalAnterior[indextempAnterior].backgroundColor = this.backgroundAnterior;
          } else {
            indextempAnterior = this.arrayCampoAdicionalAnterior.findIndex(element => {
              return element.id === temp.id;
            });
          }

          for (let l = 0; l < temp.multipleCaracterisitca.length; l++) {
            let tempoActual = temp.multipleCaracterisitca[l];

            if (tempAnterior === undefined) {
              this.arrayCampoAdicional[i].multipleCaracterisitca[l].backgroundColor = this.backgroundActual;
            } else {
              if (tempoActual.Valor_Registros != tempAnterior.multipleCaracterisitca[l].Valor_Registros) {
                this.arrayCampoAdicional[i].multipleCaracterisitca[l].backgroundColor = this.backgroundActual;
                this.arrayCampoAdicionalAnterior[indextempAnterior].multipleCaracterisitca[l].backgroundColor = this.backgroundAnterior;
              }
            }
          }
        } else {
          tempAnterior = this.arrayCampoAdicionalAnterior.find(element => element.id === temp.id);

          if (tempAnterior !== undefined) {
            indextempAnterior = this.arrayCampoAdicionalAnterior.findIndex(element => {
              return element.id === temp.id;
            });
          }

          // BIT - BIGINT - VARCHAR - TEXT_AREA - DATETIME
          if (tempAnterior !== undefined) {
            if (temp.respuesta !== tempAnterior.respuesta) {
              this.arrayCampoAdicional[i].backgroundColor = this.backgroundActual;
              this.arrayCampoAdicionalAnterior[indextempAnterior].backgroundColor = this.backgroundAnterior;
            }
          } else {
            this.arrayCampoAdicional[i].backgroundColor = this.backgroundActual;
          }
        }
      }
    } else if (option === 'documento') {
      let arrayPreguntasMultiplesDoc: Array<any> = this.arrayDocumentoAnterior;

      for (let i = 0; i < this.arrayDocumento.length; i++) {
        let temp = this.arrayDocumento[i];
        let tempAnterior: any;
        let indextempAnterior: number;


        if (temp.desc_tipo_dato === TipoCampoAdicional.Multiple) {
          let preguntasHijasAnterior: any;
          let preguntasHijasActual = temp.hijasMultiple;

          // Buscar la pregunta multiple version anterior
          for (let k = 0; k < arrayPreguntasMultiplesDoc.length; k++) {
            let tempMult = arrayPreguntasMultiplesDoc[i].hijasMultiple;

            if (temp.hijasMultiple[0].id === tempMult[0].id) {
              preguntasHijasAnterior = arrayPreguntasMultiplesDoc[i];
              break;
            }
          }

          for (let j = 0; j < preguntasHijasActual.length; j++) {
            let tempHijasActual = preguntasHijasActual[j];

            if (preguntasHijasAnterior && preguntasHijasAnterior.hijasMultiple[j]) { // edicion
              if (preguntasHijasAnterior.hijasMultiple[j].respuesta != tempHijasActual.respuesta) {
                this.arrayDocumento[i].hijasMultiple[j].backgroundColor = this.backgroundActual;
                this.arrayDocumentoAnterior[i].hijasMultiple[j].backgroundColor = this.backgroundAnterior;
              }
            } else { // nueva
              this.arrayDocumento[i].hijasMultiple[j].backgroundColor = this.backgroundActual;
            }
          }
        } else if (temp.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica) {
          tempAnterior = this.arrayDocumentoAnterior.find(element => element.id === temp.id);
          indextempAnterior = this.arrayDocumentoAnterior.findIndex(element => {
            return element.id === temp.id;
          });

          for (let l = 0; l < temp.multipleCaracterisitca.length; l++) {
            let tempoActual = temp.multipleCaracterisitca[l];

            if (tempoActual.Valor_Registros != tempAnterior.multipleCaracterisitca[l].Valor_Registros) {
              this.arrayDocumento[i].multipleCaracterisitca[l].backgroundColor = this.backgroundActual;
              this.arrayDocumentoAnterior[indextempAnterior].multipleCaracterisitca[l].backgroundColor = this.backgroundAnterior;
            }
          }
        } else {
          tempAnterior = this.arrayDocumentoAnterior.find(element => element.id === temp.id);

          if (tempAnterior !== undefined) {
            indextempAnterior = this.arrayDocumentoAnterior.findIndex(element => {
              return element.id === temp.id;
            });
          }

          // BIT - BIGINT - VARCHAR - TEXT_AREA - DATETIME
          if (tempAnterior !== undefined) {
            if (temp.respuesta !== tempAnterior.respuesta) {
              this.arrayDocumento[i].backgroundColor = this.backgroundActual;
              this.arrayDocumentoAnterior[indextempAnterior].backgroundColor = this.backgroundAnterior;
            }
          } else {
            this.arrayDocumento[i].backgroundColor = this.backgroundActual;
          }

        }
      }

    }
  }
}
